export type VornoRuntimeConfig = {
  appEnv?: string;
  supabaseUrl?: string;
  supabasePublishableKey?: string;
};

declare global {
  interface Window {
    __VORNO_DRIVE_CONFIG__?: VornoRuntimeConfig;
  }
}

const runtime = window.__VORNO_DRIVE_CONFIG__ ?? {};
const runtimeOnly = import.meta.env.VITE_RUNTIME_CONFIG_ONLY === "true";

export const runtimeConfig = Object.freeze({
  appEnv: runtime.appEnv || (runtimeOnly ? "unconfigured" : import.meta.env.VITE_APP_ENV) || "local",
  supabaseUrl: runtime.supabaseUrl || (runtimeOnly ? "" : import.meta.env.VITE_SUPABASE_URL) || "",
  supabasePublishableKey:
    runtime.supabasePublishableKey ||
    (runtimeOnly ? "" : import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY) ||
    "",
});
